module.exports = __webpack_public_path__ + "img/logo-modo.86fdbf94.svg";